import React, {useRef} from 'react';
import styled from '@emotion/styled';

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const CircularImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: contain;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

const ImageInfoText = styled.p`
  margin-top: 10px;
  font-size: 0.8rem;
  color: #666;
`;

const UploadButton = styled.button`
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;

  &:hover {
    background-color: #0056b3;
  }
`;

const ImageUploader = ({ imageSrc, onImageUpload }) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        onImageUpload(base64String);
      };
      reader.readAsDataURL(file); 
    }
  };

  return (
    <ImageContainer>
      <CircularImage src={imageSrc ? `data:image/jpeg;base64,${imageSrc}` : ''} alt="Profile" />
      <ImageInfoText>Maximum image size 5mb</ImageInfoText>
      <UploadButton onClick={handleButtonClick}>Upload New Image</UploadButton>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleImageUpload}
      />
    </ImageContainer>
  );
};

export default ImageUploader;